import { supabase } from "@/utils/supabase";

const FUNCTIONS_URL = `${process.env.VUE_APP_SUPABASE_URL}/functions/v1`;

// Edge Function 호출 (JWT 인증)
async function callFn(path, body) {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (!session) throw new Error("E_NOT_LOGGED_IN");

  const res = await fetch(`${FUNCTIONS_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.VUE_APP_SUPABASE_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify(body || {}),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw Object.assign(new Error(json.message || "E_REQUEST_FAILED"), { detail: json });
  }
  return json;
}

export default {
  // 내 재화 잔액. user_id 명시 필터 필수 — 관리자(admin_read_* 정책)는 RLS상 전체 행이 보여서
  // 필터 없이 .maybeSingle() 하면 다중행 에러로 0이 됨. (UI는 🥕)
  async fetchBalance() {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const uid = session?.user?.id;
    if (!uid) return 0;
    const { data } = await supabase.from("user_currency").select("balance").eq("user_id", uid).maybeSingle();
    return (data && data.balance) || 0;
  },

  // 차감 (가챠 등). 클라는 쓰기 불가 → Edge Function(service_role) 경유. 차감 후 잔액 반환.
  async spend(amount, reason) {
    const json = await callFn("/currency/spend", { amount, reason });
    return json.balance;
  },

  // 아이템 구매 (당근 차감 + 인벤토리 적립, 원자적). Edge → buy_item RPC.
  // 반환: { balance, qty } (구매 후 잔액 + 해당 아이템 보유 수량)
  async buyItem(itemId, qty = 1) {
    return await callFn("/currency/buy-item", { itemId, qty });
  },

  // 출석 보상 설정(1~7일차 🥕) — ssot 공개 읽기.
  async fetchAttendanceRewards() {
    const { data } = await supabase.from("ssot").select("value").eq("key", "ATTENDANCE_REWARDS").maybeSingle();
    const v = data && data.value;
    return Array.isArray(v) && v.length === 7 ? v : [10, 25, 50, 80, 120, 160, 200];
  },

  // 내 출석 상태 (누적일수/마지막 출석일). user_id 명시 필터 — 관리자 admin_read 정책 다중행 회피.
  async fetchAttendance() {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const uid = session?.user?.id;
    if (!uid) return { totalDays: 0, lastCheckDate: null };
    const { data } = await supabase
      .from("user_attendance")
      .select("total_days, last_check_date")
      .eq("user_id", uid)
      .maybeSingle();
    return {
      totalDays: (data && data.total_days) || 0,
      lastCheckDate: (data && data.last_check_date) || null,
    };
  },

  // 출석하기 → Edge Function(service_role)에서 claim_attendance 처리.
  // 반환: { already, day, reward, total_days, balance }
  async attend() {
    return await callFn("/currency/attend", {});
  },
};
